/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState,useRef } from "react";
import "./lead-qualification-merge-lead-fuzzy-matching.scss";
import { getLeads } from "../../../../api/lead";
import { useLogin } from "../../../../common/hooks/useUser";
import { MUITable, PaginationComponent } from "../../../../common/components";
import LeadsStatus from "../../lead-qualification-leads-status";
import LeadQualificationMergeLeadsPopups from "../../lead-qualification-popups/lead-qualification-merge-leads-popups/lead-qualification-merge-leads-popups";

const LeadQualificationMergeLeadFuzzyMatching: any = (props: any) => {
 const { setLoading, setAlertMessage, setAlertType,  setAlertOpen, payload  } = props;
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [data, setData] = useState<any[]>([]);
  const [isShowMergeLeadsPopups, setIsShowMergeLeadsPopups] = useState<any>(false);
  const [selectedLeadId, setSelectedLeadId] = useState<any[]>([]);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(0);

  const userDetails = useLogin();

  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const fetchLeads = async (page = 1) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      const params: any = {
        limit: pageSize,
        offset: offset,
        fuzzyMatching: true,
        criteriaParam: payload?.selectCriteria,
      };
      const response = await getLeads(params);
      setData(response.data.data.rows);
      setTotalRecords(response.data.data.totalCount);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch Leads");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchLeads( currentPage);
  }, [currentPage, payload]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const headers = [
    { key: "duplicateNumber", label: "Duplicate Found", isSortable: false },
    { key: "leadName", label: "Lead Name", isSortable: false },
    { key: "email", label: "Email", isSortable: false },
    { key: "phone", label: "Phone Number", isSortable: false },
    { key: "leadSource", label: "Lead Source", isSortable: false },
    { key: "leadOwner", label: "Lead Owner", isSortable: false },
    { key: "leadStatus", label: "Lead Status", isSortable: false },
    { key: "mergeAction", label: "Merge Action", isSortable: false },
  ];


  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const fullName =
      firstName && lastName
        ? `${firstName} ${lastName}`
        : firstName
          ? firstName
          : lastName
            ? lastName
            : "-";
    return fullName;
  }

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item: any) => {
        return {
          duplicateNumber: item.duplicatesFound || "-",
          id: item?.id,
          leadName: item?.leadNames || "-",
          email: item?.emails || "-",
          phone: item?.phones || "-",
          leadSource: item?.leadSources || "-",
          leadOwner:item?.leadOwners,
          leadStatus: item?.leadStatuses || "-",
          mergeAction: <button
            className="lead-qualification-merge-lead-fuzzy-matching-table-button"
            onClick={() => {setIsShowMergeLeadsPopups(true)
              setSelectedLeadId(item?.leads || []);
            }}
          >
            {"Merge"}
          </button>,
        };
      });
    }
    return [];
  }, [data, leadOwner]);

  useEffect(() => {
    if (!containerRef?.current) return;
    // ResizeObserver updates width whenever sidebar opens/closes or window resizes
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setWidth(entry?.contentRect?.width);
      }
    });

    observer.observe(containerRef?.current);

    return () => observer?.disconnect();
  }, [containerRef]);

  return (
    <>
      <div
        ref={containerRef}
        className="lead-qualification-merge-lead-fuzzy-matching"
      >
        <div className="lead-qualification-merge-lead-fuzzy-matching-table-pagination">
          <div className="results-text-and-table-container">
            <div className="lead-qualification-merge-lead-fuzzy-matching-header">
              <div className="lead-qualification-merge-lead-fuzzy-matching-header-main-text">
                {`Result (By ${payload?.selectCriteria === "primary_phone_number" ? "Phone Number" : "Email"})`}
              </div>
              <div className="lead-qualification-merge-lead-fuzzy-matching-header-sub-text">
                After clicking the Merge button, you’ll be asked to select one lead as the primary. All other similar leads will be merged into it, combining their details into a single, complete profile.
              </div>
            </div>
            <div
              className={`lead-qualification-merge-lead-fuzzy-matching-table lead-qualification-merge-lead-fuzzy-only-matching-table ${width > 1300 ? "lead-qualification-merge-lead-fuzzy-only-matching-table-result-text-single-line" : ""}`}
            >
              <MUITable
                headers={headers}
                  data={formattedData.map((item) => ({
                    key: item.id,
                    leadName: item.leadName,
                    email: item.email,
                    phone: item.phone,
                    leadSource: item.leadSource,
                    leadOwner: item.leadOwner,
                    leadStatus: <LeadsStatus status={item.leadStatus} />,
                    mergeAction: item.mergeAction,
                    duplicateNumber: item.duplicateNumber,
                  }))}
                noResultsTxt={"No data found"}
              />
            </div>
            {totalRecords && totalRecords > 0 ? (
              <div className="leads-pagination-containers qualification-leads-pagination">
                    <PaginationComponent
                      totalRecords={totalRecords}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
              </div>
            ) : (
              <></>
              )} 
          </div>  
        </div>
      </div>
      {isShowMergeLeadsPopups ? (
          <LeadQualificationMergeLeadsPopups
          setIsShowMergeLeadsPopups={setIsShowMergeLeadsPopups}
            isShowMergeLeadsPopups={isShowMergeLeadsPopups}
            data={selectedLeadId}
            fetchFullName={fetchFullName}
            setSelectedLeadId={setSelectedLeadId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            fetchLeads={fetchLeads}
            selectCriteria={payload?.selectCriteria}
          />
        ): ""}
    </>
  );
};

export default LeadQualificationMergeLeadFuzzyMatching;